import React, { useState, useEffect } from 'react';
import { Menu, X, Code, ChevronDown, Phone, Mail } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            setIsMenuOpen(false);
        }
    };

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
            }`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="flex items-center justify-between h-16">
                    <div className="flex items-center space-x-2">
                        <div className="bg-blue-100 p-2 rounded-lg">
                            <img src='./logo.png' className='w-8 h-8' />
                        </div>
                        <span className="text-xl font-bold text-gray-900">Newline Infotech</span>
                    </div>

                    <nav className="hidden md:flex items-center space-x-8">
                        <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-blue-600 transition-colors">
                            Home
                        </button>
                        <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors">
                            Services
                        </button>
                        <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-blue-600 transition-colors">
                            Products
                        </button>
                        <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-600 transition-colors">
                            About
                        </button>
                        <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 transition-colors">
                            Contact
                        </button>
                        <div className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                            <div className='flex flex-col gap-1'>
                                <div className='flex gap-2 items-center'>
                                    <Phone className='w-3 h-3' />
                                    <p className='text-xs'>+91 9352515824</p>
                                </div>
                                <div className='flex gap-2 items-center'>
                                    <Mail className='w-3 h-3' />
                                    <p className='text-xs'>support@nipl.in</p>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <div className='md:hidden flex gap-2'>
                        <div className=" bg-blue-600 text-white px-4 py-2 flex flex-col items-center justify-center rounded-lg hover:bg-blue-700 transition-colors">
                            <div className='flex flex-row items-center gap-4'>
                                <div className='flex gap-2 items-center'>
                                    <Phone className='w-3 h-3' />
                                    <p className='text-xs'>+91 9352515824</p>
                                </div>
                                <div className='flex gap-2 items-center'>
                                    <Mail className='w-3 h-3' />
                                    <p className='text-xs'>support@nipl.in</p>
                                </div>
                            </div>
                        </div>

                        <button
                            className="md:hidden p-2"
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                        >
                            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                        </button>
                    </div>
                </div>

                {isMenuOpen && (
                    <div className="md:hidden bg-white border-t border-gray-200 py-4">
                        <nav className="flex flex-col space-y-4">
                            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-blue-600 transition-colors text-left">
                                Home
                            </button>
                            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors text-left">
                                Services
                            </button>
                            <button onClick={() => scrollToSection('products')} className="text-gray-700 hover:text-blue-600 transition-colors text-left">
                                Products
                            </button>
                            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-blue-600 transition-colors text-left">
                                About
                            </button>
                            <button onClick={() => scrollToSection('contact')} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-left">
                                Contact
                            </button>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;